// extracted by mini-css-extract-plugin
export default {"wrapper":"gp-z","response":"hp-z","error":"ip-z","disabled":"jp-z","buttons":"kp-z","feedbackQuestionSection":"lp-z","yesNoWrapper":"mp-z"};